import { AnyARecord } from "dns";
import { StringChain } from "lodash";
import { BondDetail } from "./bond-detail";
import { BondPay } from "./bond-pay";

export class Bond {
    id: number;
    bondType: string;
    company: any;
    companyCostCenter: any;
    companyTarget: any;
    supplier: any;
    docType: any;
    document: string;
    person: any;
    firm: any;
    professional: any;
    performer: any;
    insurance: any;
    patient: any;
    user: any;
    note: any;
    parcelNumber: string;
    value: number;
    dueDate: string;
    accrualMonth: any;
    accrualYear: any;
    originDate: string;
    discountAt: string;
    typeDebtorOrCreditor: string;
    bondParent: any;
    bondDetail: BondDetail;
    bondPay: BondPay;
    totalPay: number;
    companyAccountPlan: any;
    sendingToFinanceItemId: number;
    originBond: string;
    apportionment?: Array<any>;
}
